import React, { useEffect } from 'react';

const CrusaderPage = () => {
  useEffect(() => {
    // Redirect to standalone HTML page
    window.location.href = '/crusader.html';
  }, []);

  return null;
};

export default CrusaderPage;
